import React, { Component } from 'react';
import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween.js';
import { Divider, Flex } from 'antd';
import { CaretUpOutlined, CaretDownOutlined, UpCircleFilled } from '@ant-design/icons';
import { Form, Space, TimePicker, Button, InputNumber, message } from 'antd';
import _ from 'lodash';

dayjs.extend(isBetween);

const FormItem = Form.Item;

class DetailedScheduleEditTimeForm extends Component {
    formRef = React.createRef();
    constructor(props) {
        super(props);
        let st = dayjs(props.editValue.startTime.$d);
        let et = dayjs(props.editValue.endTime.$d)
        let du = dayjs(props.editValue.endTime).diff(dayjs(props.editValue.startTime), 'minute') / 60
        this.state = {
            startTime: st,
            endTime: et,
            duration: du,
            label: props.labelValue,
            tourTimes: props.tourTimes,
            tour: props.tour,
            changeTour: false
        }
    }

    validateForm = () => {
        let validationObject = {
            value: false,
            message: ''
        };

        const start = this.state.startTime;
        const end = this.state.endTime;
        const tourStart = this.state.tourTimes.startTime;
        const tourEnd = this.state.tourTimes.endTime;
        // Added
        // const meals = this.state.tour.meals;
        // const assignments = this.state.tour.serviceOrders;

        switch (this.state.label) {
            case 'tourTimes': // Here
                validationObject.value = true;
                break;
            case 'mealTimes':
                if (
                    start.isBetween(tourStart, tourEnd, null, '[]') &&
                    end.isBetween(tourStart, tourEnd, null, '[]')
                ) {
                    validationObject.value = true;
                    break;
                } else {
                    validationObject.message = 'Meals must be within the tour times.';
                    break;
                }
            case 'assignTimes':
                if (
                    (start.isBetween(tourStart, tourEnd, null, '[]') &&
                        end.isBetween(tourStart, tourEnd, null, '[]')
                    ) || !this.state.tourTimes.isApproved
                ) {
                    validationObject.value = true;
                    this.state.changeTour = true;
                    break;
                } else {
                    validationObject.message = 'Assignment times must be within the tour times.';
                    break;
                }
            default:
                break;
        }

        return validationObject;
    }

    handleSubmit = (e) => {


        const validation = this.validateForm();

        if (validation.value) {
            let returnValue = {
                timeStart: this.state.startTime,
                timeEnd: this.state.endTime,
                changeTour: this.state.changeTour
            };
            this.props.handleComponentEditSubmit(returnValue, this.state.label);
        } else {
            message.error(validation.message);
        }
    }

    handleStartTimeChange = (e) => {
        if (e) {
            if (this.state.label === 'mealTimes') {
                this.setStartTime(e);
            } else if (this.state.label === 'tourTimes') {
                this.setStartTime(e);
            } else if (this.state.label === 'assignTimes') {
                this.setStartTime(e);
            }
        }
    }

    handleEndTimeChange = (e) => {
        if (e) {
            if (this.state.label === 'mealTimes'
                && e.diff(this.state.tourTimes.endTime, 'minutes') / 60 <= 0
                && e.diff(this.state.startTime, 'minutes') / 60 > 0) {
                this.setEndTime(e);
            } else if (this.state.label === 'tourTimes' || this.state.label === 'assignTimes') {
                if (e.diff(this.state.startTime, 'minutes') / 60 <= 0) {
                    e.add(1, 'days');
                }
                this.setEndTime(e);
            }
        }
    }

    handleDurationChange = (value) => {
        const roundedValue = this.roundToQuarters(value);

        let clonedStartTime = _.cloneDeep(this.state.startTime);
        if ((this.state.label === 'mealTimes' && roundedValue > 0 && clonedStartTime.add(roundedValue, 'hours').diff(this.state.tourTimes.endTime, 'minutes') / 60 <= 0)
            || (this.state.label === 'tourTimes' && value > 0 && value <= 168)
            || (this.state.label === 'assignTimes' && value > 0 && value <= 168)) {
            this.setDuration(roundedValue);
        } else {
            this.setState({ duration: this.state.endTime.diff(this.state.startTime, 'minutes') / 60 });
        }

    }

    roundToQuarters = (input) => {
        if (/^\d+(\.\d+)?$/.test(input)) {
            const number = parseFloat(input)
            const roundedNumber = Math.floor(number * 4) / 4;
            return roundedNumber;
        }
        return 0;
    }

    setStartTime = (e) => {
        const newEndTime = e.add(this.state.duration, 'hour');
        this.setState({
            startTime: e,
            endTime: newEndTime
        }, () => {
            this.formRef.current.setFieldsValue({ startTime: e, endTime: newEndTime })
        });
    }

    setEndTime = (e) => {
        const newDuration = e.diff(this.state.startTime, 'minute') / 60;
        this.setState({
            endTime: e,
            duration: newDuration
        }, () => {
            this.formRef.current.setFieldsValue({ endTime: e, duration: newDuration })
        });
    }

    setDuration = (value) => {
        const newEndTime = this.state.startTime.add(value, 'hour');
        this.setState({
            duration: value,
            endTime: newEndTime
        }, () => {
            this.formRef.current.setFieldsValue({ duration: value, endTime: newEndTime })
        });
    }

    handleCancel = () => {
        this.props.handleEditCancel();
    }


    render() {
        const initValues = {
            startTime: this.state.startTime,
            endTime: this.state.endTime,
            duration: this.state.duration
        };
        return (
            <Form ref={this.formRef} onFinish={this.handleSubmit} initialValues={initValues}>
                <Form.Item name="startTime" label="Start Time">
                    <TimePicker
                        label="Start Time"
                        format={{ format: 'h:mm a', type: 'mask' }}
                        onChange={this.handleStartTimeChange}
                        value={this.state.startTime}
                        styles={{
                            popup: {
                                root: {
                                    zIndex: 2000
                                }
                            }
                        }}
                        name="startTime"
                        allowClear={false}
                        use12Hours={true}
                        minuteStep={15}
                        inputReadOnly={true}
                        showNow={false}
                    />

                </Form.Item>
                <Form.Item name="endTime" label="End Time">
                    <TimePicker
                        label="End Time"
                        format={{ format: 'h:mm a', type: 'mask' }}
                        onChange={this.handleEndTimeChange}
                        value={this.state.endTime}
                        styles={{
                            popup: {
                                root: {
                                    zIndex: 2000
                                }
                            }
                        }}
                        name="endTime"
                        allowClear={false}
                        use12Hours={true}
                        minuteStep={15}
                        inputReadOnly={true}
                        showNow={false}
                    />

                </Form.Item>
                <Form.Item name="duration" label="Duration">
                    <Flex gap={0}>
                        <InputNumber
                            name="duration"
                            value={this.state.duration}
                            onBlur={(event) => this.handleDurationChange(event.target.value)}
                            min={0}
                            controls={false}
                            type="number"
                            placeholder='duration'
                        />
                        <Flex vertical justify='space-between' gap={0} style={{ marginLeft: '-1em', zIndex: 1000 }}>
                            <CaretUpOutlined style={{}} onClick={() => this.handleDurationChange(this.state.duration + 1)} />
                            <CaretDownOutlined style={{}} onClick={() => this.handleDurationChange(this.state.duration - 1)} />
                        </Flex>
                    </Flex>
                </Form.Item>
                <Form.Item>
                    <Divider />
                    <Space size={"large"}>
                        <Button label={null} color="danger" variant="solid" onClick={this.handleCancel}>Cancel</Button>
                        <Button
                            label={null}
                            type="primary"
                            htmlType="submit"
                            disabled={this.props.buttonDisable}
                        >Submit</Button>
                    </Space>
                </Form.Item>
            </Form>
        );
    }
}

export default DetailedScheduleEditTimeForm;
